import { useState } from 'react'; 
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Button from '@mui/material/Button';   
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './navigationBar.css'; 

export default function SignOutMenu(props) {  
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
      setAnchorEl(null);
  };      
  return (
    <div> 
      <Button className='menu-subheader' startIcon={<AccountCircleIcon/>} endIcon={<KeyboardArrowDownIcon />} onClick={handleClick}>
        {props.user.username}
      </Button> 
      <Menu 
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      > 
        <MenuItem onClick={props.signOut}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sign Out</ListItemText> 
        </MenuItem>      
      </Menu>
    </div>
  );
}


        // <MenuItem sx={{fontSize: "15px"}} onClick={props.signOut}>
        //     Sign Out
        // </MenuItem>